import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Paragraph", "tagName", "text", "maxChars"];
import { Paragraph as TParagraph } from '../Paragraph';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const LAST_WHITESPACE_REGEX = /\s(?!.+\s)/m;
const truncateStr = (str, maxLength) => {
  if (str.length <= maxLength) return null;
  const minLength = maxLength - 20;
  const lastWordBoundaryMatch = str.slice(0, maxLength).match(LAST_WHITESPACE_REGEX);
  if (lastWordBoundaryMatch && lastWordBoundaryMatch.index && lastWordBoundaryMatch.index > minLength) {
    return `${str.slice(0, lastWordBoundaryMatch.index)}…`;
  }
  return `${str.slice(0, maxLength)}…`;
};
const StyledTruncateMultilineWrapper = styled.span.withConfig({
  displayName: "TruncateMultiline__StyledTruncateMultilineWrapper",
  componentId: "at28v6-0"
})(({
  $cssStyles
}) => Object.assign({}, $cssStyles));
export const TruncateMultiline = _ref => {
  let {
      Paragraph = TParagraph,
      tagName = 'span',
      text,
      maxChars = Infinity
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  let remainingLength = maxChars;
  const rawParagraphs = typeof text === 'string' ? [text] : text;
  const paragraphNodes = [];
  for (let i = 0; i < rawParagraphs.length && remainingLength > 0; i++) {
    const rawParagraph = rawParagraphs[i];
    const truncatedParagraph = truncateStr(rawParagraph, remainingLength);
    if (truncatedParagraph) {
      paragraphNodes.push( /*#__PURE__*/_jsx(Paragraph, {
        children: truncatedParagraph
      }, i));
      break;
    } else {
      paragraphNodes.push( /*#__PURE__*/_jsx(Paragraph, {
        children: rawParagraph
      }, i));
      remainingLength -= rawParagraph.length;
    }
  }
  return /*#__PURE__*/_jsx(StyledTruncateMultilineWrapper, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    as: tagName,
    children: paragraphNodes
  }));
};